import React from "react";
import "./Terms.css";

export default function Terms() {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms & Conditions</h1>

      <p className="terms-text">
        This website is owned and operated by OurCountryOurPeople Foundation.
        OurCountryOurPeople Foundation provides this website, including all information, software and services
        available on this website, to you, the user, conditioned upon your acceptance
        of all the terms, conditions, policies and notices stated here. Your use of the
        website constitutes your agreement to all such terms, conditions, policies and notices.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using the OurCountryOurPeople Foundation website, you agree to comply with these
        terms and conditions. This website is for your personal and non-commercial use.
        If you do not agree, please refrain from using the website.
      </p>

      <h2>2. Intellectual Property</h2>
      <p>
        All content on this website, including text, graphics, logos and images,
        is the property of OurCountryOurPeople Foundation and is protected by intellectual property laws.
        Unauthorized use is prohibited.
      </p>

      <h2>3. Privacy Policy</h2>
      <p>
        Your privacy is central to the collection, handling, use, disclosure and
        protection of handling of information as described in OurCountryOurPeople Foundation privacy policy
        located at Privacy Policy. Such policy may be amended by OurCountryOurPeople Foundation in its sole
        discretion from time to time.
      </p>

      <h2>4. Donations</h2>
      <p>
        Any donations made through our website are subject to the terms outlined in
        our Donation Policy outlined in our Conditions & Refund Policy.
      </p>

      <h2>5. User Conduct</h2>
      <p>
        You agree to use the website responsibly and not engage in any unlawful or
        harmful activities.
      </p>

      <h2>6. External Links</h2>
      <p>
        Our website may contain links to third-party websites. We are not responsible
        for the content or practices of these sites.
      </p>

      <h2>7. Modifications</h2>
      <p>
        OurCountryOurPeople Foundation reserves the right to modify these terms at any time. It is your
        responsibility to review them periodically.
      </p>

      <h2>8. Disclaimer</h2>
      <p>
        The information on this website is for general purposes only. OurCountryOurPeople Foundation does
        not guarantee its accuracy or completeness.
      </p>

      <h2>9. Governing Law</h2>
      <p>
        These terms are governed by the laws of India. Any disputes will be resolved
        in the courts of (City, State).
      </p>

      <h2>10. Contact Information</h2>
      <p>
        If you have any questions or concerns regarding these terms, please contact us
        at <strong>(namnadunammakkall@gmail.com / +91 98406 93733)</strong>.
      </p>
    </div>
  );
}
